import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Plus, X } from "lucide-react";
import { checkFile } from "./PhotoPicker";

export const MemoriesPicker = ({ files, captions, onChange, max = 3 }) => {
  const { t } = useTranslation();
  const input = useRef();
  const previews = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
  useEffect(() => () => previews.forEach((u) => URL.revokeObjectURL(u)), [previews]);
  const add = (list) => {
    const ok = Array.from(list).filter((f) => checkFile(t, f));
    const next = [...files, ...ok].slice(0, max);
    onChange(next, next.map((_, i) => captions[i] || ""));
  };
  return (
    <div data-testid="wizard-memories">
      <p className="field-label">{t("wizard.memories")} <span className="font-normal text-[hsl(var(--muted-foreground))]">({files.length}/{max})</span></p>
      <p className="text-xs text-[hsl(var(--muted-foreground))] mb-3 max-w-md">{t("wizard.memories_hint")}</p>
      <div className="flex flex-wrap gap-3">
        {previews.map((src, i) => (
          <figure key={src} className="w-36 anim-rise" data-testid={`wizard-memory-${i}`}>
            <div className="relative h-28 w-36 rounded-2xl overflow-hidden border">
            <img src={src} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(files.filter((_, j) => j !== i), captions.filter((_, j) => j !== i))} className="absolute top-1.5 end-1.5 h-7 w-7 grid place-items-center rounded-full bg-black/60 text-white hover:bg-black/80 transition-colors" aria-label={t("wizard.photo_remove")} data-testid={`wizard-memory-remove-${i}`}>
              <X size={14} />
            </button>
            </div>
            <input type="text" maxLength={80} dir="auto" value={captions[i] || ""} onChange={(e) => onChange(files, captions.map((c, j) => (j === i ? e.target.value : c || "")))} placeholder={t("wizard.caption_placeholder")} aria-label={t("wizard.caption")} className="field-input !py-1.5 !px-2.5 !text-xs mt-2" data-testid={`wizard-memory-caption-${i}`} />
          </figure>
        ))}
        {files.length < max && (
          <button type="button" onClick={() => input.current?.click()} className="h-28 w-28 rounded-2xl border-2 border-dashed border-[hsl(var(--border))] hover:border-[hsl(var(--accent))] grid place-items-center text-xs text-[hsl(var(--muted-foreground))] bg-[hsl(var(--secondary))] transition-colors" data-testid="wizard-memory-add-btn">
            <span className="flex flex-col items-center gap-1.5"><Plus size={20} /> {t("wizard.memories_add")}</span>
          </button>
        )}
      </div>
      <input ref={input} type="file" multiple accept="image/jpeg,image/png,image/webp" className="hidden" data-testid="wizard-memory-file-input" onChange={(e) => { add(e.target.files || []); e.target.value = ""; }} />
    </div>
  );
};
